<template>
    <article
        ref="warn"
        class="pf-favorite-warn">
        <button
            class="pf-favorite-warn__hide"
            @click.prevent="hideWarn"></button>
        <div class="pf-favorite-warn__wrap">
            <h3
                class="pf-favorite-warn__title"
                :title="title"
                v-html="title"></h3>
            <p
                class="pf-favorite-warn__desc"
                v-html="desc"></p>
            <a
                class="pf-favorite-warn__link"
                :href="link.href"
                :title="link.text"
                v-html="link.text"></a>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'FavoriteWarn',
        data() {
            return {
                title: 'Объект добавлен в Избранное',
                desc: 'Данные об объектах в Избранном сохраняются в cookie вашего браузера и будут отображаться до момента очистки cookie в браузере',
                link: {
                    text: 'Перейти в избранное',
                    href: '/property/favorites/'
                },
            }
        },
        methods: {
            hideWarn () {
                if (this.$refs.warn?.classList.contains('active')) {
                    this.$refs.warn.classList.remove('active')
                }
                
                setTimeout(() => this.$emit('hideWarn'), 300)
            },
        },
        mounted() {
            if (!this.$refs.warn?.classList.contains('active')) {
                setTimeout(() => this.$refs.warn.classList.add('active'), 100)
            }
            
            setTimeout(() => this.hideWarn(), 5000)
        }
    }
</script>